module.exports = __webpack_public_path__ + "img/client_ride.29ab89a8.svg";